module.exports = "<p>\n  dialog works!\n</p>\n"